import { colorScales } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { iconStyle, type LiveStatusIconSize } from "../LiveAppIcons";
export function OutOfSyncIcon(size: LiveStatusIconSize) {
    return (<span className={iconStyle(size)} style={{ background: colorScales.orange[500] }}>
            <em className="fa-solid fa-arrow-up"/>
        </span>);
}
